import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { UsersListPage } from '@/components/user/UsersListPage';
import { userApi } from '@/lib/pillarApi';
import { Role, type UserProfileDetailedPublicResponse } from '@anchorbase/pillar-sdk';
import { z } from 'zod';

const CUSTOMER_USERS_ROLE_LABELS: Partial<Record<Role, string>> = {
    PRINCIPAL: 'Principal',
    ADMIN: 'Admin',
    REP: 'Rep',
};

export default function CustomerUsersPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <UsersListPage<UserProfileDetailedPublicResponse, string>
                    title="Customer Users"
                    cardTitle="Customer Users"
                    roles={CUSTOMER_USERS_ROLE_LABELS}
                    queryKeyPrefix={['userListing', 'customer_users']}
                    fetchPage={userApi.listCustomerUsersPage}
                    parseCursorParam={(pageParam: unknown) => {
                        if (pageParam === null || pageParam === undefined) {
                            return undefined;
                        }
                        const parseResult = z.string().trim().min(1).safeParse(pageParam);
                        if (!parseResult.success) {
                            throw new Error('Expected opaque cursor');
                        }
                        return parseResult.data;
                    }}
                />
            </MainLayout>
        </ProtectedRoute>
    );
}
